module.exports = __webpack_public_path__ + "media/images/element/07-6a792c708ff3f2e71507d412c6f76c49.png";